interface TreeDataNode {
  title: string;
  key: string;
  children?: TreeDataNode[];
  isLeaf?: boolean;
}

export function buildTreeFromPaths(paths: string[]): TreeDataNode[] {
  type InternalNode = {
    title: string;
    key: string;
    children?: Record<string, InternalNode>;
    isLeaf?: boolean;
  };

  const root: Record<string, InternalNode> = {};

  for (const rawPath of paths) {
    if (!rawPath) continue;

    const parts = rawPath.split("/").filter(Boolean);

    let currentLevel = root;
    let currentPath = "";

    parts.forEach((part, index) => {
      currentPath += "/" + part;

      if (!currentLevel[part]) {
        currentLevel[part] = {
          title: part,
          key: currentPath,
        };
      }

      const isLast = index === parts.length - 1;
      const node = currentLevel[part];

      if (isLast) {
        node.isLeaf = true;
        delete node.children;
      } else {
        if (!node.children) {
          node.children = {};
        }
        currentLevel = node.children;
      }
    });
  }

  const convert = (level: Record<string, InternalNode>): TreeDataNode[] => {
    return Object.values(level).map((node) => {
      if (node.children && Object.keys(node.children).length > 0) {
        return {
          title: node.title,
          key: node.key,
          children: convert(node.children),
        };
      }

      return {
        title: node.title,
        key: node.key,
        isLeaf: true,
      };
    });
  };

  return convert(root);
}
